import {connect} from 'react-redux';
import ReactModal from 'react-modal';
import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';

import * as ApiConst from '../../constants/Api';
import * as LocalStorageUtils from '../../utils/LocalStorage';
import * as LocalStorageConst from '../../constants/LocalStorage';
import {
    loginEmail,
    showRegModal,
    showAuthModal,
    changeVisibleRestorePasswordFirstStep
} from '../../actions/User';
import {getRedirectUri} from "../../utils/FacebookUtils";

const defaultProps = {
    loginEmail: (email, password) => {
    },
    showRegModal: isShowRegModal => {
    },
    showAuthModal: isShowAuthModal => {
    }
};

class Authorization extends Component {
    showAuthModal(event, isShowAuthModal) {
        event.preventDefault();

        this.props.showAuthModal(isShowAuthModal);
    }

    showRegModal(event, isShowRegModal) {
        event.preventDefault();

        this.props.showRegModal(isShowRegModal);
    }

    handleClickLoginFacebook = event => {
        event.preventDefault();

        LocalStorageUtils.set(LocalStorageConst.KEYS.PATHNAME_AFTER_AUTH, this.props.location.pathname);


        window.location.href = ApiConst.FACEBOOK_LOGIN_URL + "?redirectURI=" + getRedirectUri();
    };

    handleClickLoginEmail(event) {
        event.preventDefault();

        this.props.loginEmail(this.email.value, this.password.value, false);
    }

    handleClickResetPassword(event) {
        event.preventDefault();

        this.props.showAuthModal(false);
        this.props.changeVisibleRestorePasswordFirstStep(true)
    }

    render() {
        const i18n = this.props.i18n;
        return (
            <ReactModal
                className="popup enter"
                overlayClassName="popup-overlay"
                isOpen={this.props.isShowAuthModal}
            >
                <div onClick={(event) => this.showAuthModal(event, false)} className="popup-close"/>
                <div className="popup-title">
                    {i18n['authorization.loginToYourAccount']}
                </div>
                <div className="auth-with">
                    <a href="" className="fb" onClick={this.handleClickLoginFacebook}>
                        <span/>
                        {i18n['authorization.viaFacebook']}
                    </a>
                </div>
                {this.props.isShowWrongDataMessage && <div className="p-wrong-data-message">
                    {i18n['authorization.wrongDataMessage']}
                </div>}
                <form>
                    <input
                        type="email"
                        placeholder="E-mail"
                        className="text-field"
                        ref={ref => {
                            this.email = ref
                        }}
                    />
                    <input
                        type="password"
                        className="text-field"
                        placeholder={i18n['authorization.password']}
                        ref={ref => {
                            this.password = ref
                        }}
                    />
                    {process.env.NODE_ENV === 'development' && <label className="checkbox">
                        <input type="checkbox"/>
                        <span>{i18n['authorization.rememberMe']}</span>
                    </label>}
                    <div className="submit-box">
                        <button className="btn" type="submit" onClick={::this.handleClickLoginEmail}>
                            {i18n['authorization.signIn']}
                        </button>
                    </div>
                    <div style={{textAlign : 'center'}}>
                        <a href="" className="pink" onClick={::this.handleClickResetPassword}>
                            {i18n['authorization.forgotYourPassword']}?
                        </a>
                    </div>
                </form>
                <div className="popup-reg-action">
                    <div>{i18n['authorization.youHaveNotRegisteredYet']}?</div>
                    <a href="" onClick={(event) => this.showRegModal(event, true)} className="pink">
                        {i18n['authorization.signUp']}
                    </a>
                </div>
            </ReactModal>
        )
    }
}

Authorization.defaultProps = defaultProps;

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    isShowAuthModal: state.user.isShowAuthModal,
    isShowWrongDataMessage: state.user.isShowWrongDataMessage
});

const mapDispatchToProps = {
    loginEmail,
    showRegModal,
    showAuthModal,
    changeVisibleRestorePasswordFirstStep
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Authorization));



// WEBPACK FOOTER //
// ./src/components/Base/Authorization.js